module.exports = __webpack_public_path__ + "static/media/rsvp_notification.e6d3faef.png";